// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5707 ? "e0607d60" : chunkId) + "." + {"267":"59f194f30aab9110","5707":"6cf7beff2e8ddec6"}[chunkId] + ".js";
};